import { useQuery } from '@tanstack/react-query';

import { Role } from '@app/domain-interfaces';
import { Auth, Axios } from '@app/web-components';

import { bundleKeys } from '../bundles';

export const useGetMyAccessRequests = () => {
  const axios = Axios.useAxiosApi();

  return useQuery({
    queryKey: ['my-access-requests'],
    queryFn: () => axios.get('/user/me/access-requests').then((response) => response.data),
  });
};

export const useGetMyBundles = () => {
  const axios = Axios.useAxiosApi();
  const { user } = Auth.useUserAuth();

  return useQuery({
    queryKey: bundleKeys.list({ userId: user?.id }),
    queryFn: () => axios.get('/user/me/bundles').then((response) => response.data),
    enabled: user && (user.roles[Role.BUNDLE_ADMIN] || user.roles[Role.SYSTEM_ADMIN]),
  });
};

export const useGetMySubscriptions = () => {
  const axios = Axios.useAxiosApi();

  return useQuery({
    queryKey: ['my-subscriptions'],
    queryFn: () => axios.get('/user/me/subscriptions').then((response) => response.data),
  });
};
